export default __webpack_public_path__ + "static/media/background-sample.1ef46394.png";